import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import Styles from './TransactionsStatsCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { AnalyticsDataCard } from 'Components'
import AnalyticsSelectors from 'Stores/Analytics/Selectors'
import AnalyticsActions from 'Stores/Analytics/Actions'
import RequestState from 'Enums/RequestState'
import { formatNumber } from 'Utils/Calculations'
import { useTranslation } from 'react-i18next'
import { getEnergyUnit } from 'Utils/Calculations'

const TransactionsStatsCard = ({
  transactionsStatistics,
  fetchTransactionsStatistics,
  fetchTransactionsStatisticsRequestState,
  currency,
  filter,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    fetchTransactionsStatistics(filter)
  }, [])
  useEffect(() => {
    fetchTransactionsStatistics(filter)
  }, [filter])
  const chargedValue = transactionsStatistics?.data?.kwhCharged || 0

  const { divisor, unit } = getEnergyUnit(chargedValue)
  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      <div className={Styles.Top}>
        <AnalyticsDataCard
          title={t('Analytics.Revenue')}
          subtitle={t('Analytics.SinceThisMonth')}
          percentage={transactionsStatistics?.data?.transactionRevenueChange}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.transactionRevenue,
          )}
          unit={currency}
          body={` ${
            transactionsStatistics?.data?.averagePerCharge
              ? formatNumber(transactionsStatistics?.data?.averagePerCharge)
              : '-'
          } ${t('Analytics.AverageRevenue')}`}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />

        <AnalyticsDataCard
          title={t('Analytics.Co2')}
          subtitle={t('Analytics.SinceThisMonth')}
          percentage={transactionsStatistics?.data?.co2SavedChange}
          primaryValue={formatNumber(transactionsStatistics?.data?.co2Saved)}
          unit={t('Analytics.Kg')}
          body={` ${
            transactionsStatistics?.data?.averagePerCharge
              ? formatNumber(transactionsStatistics?.data?.co2Emitted)
              : '-'
          } ${t('Analytics.Emitted')}`}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.CarbonFootprint')}
          primaryValue={formatNumber(transactionsStatistics?.data?.co2Saved)}
          unit={t('Analytics.Kg')}
          secondaryValue={formatNumber(transactionsStatistics?.data?.fuelSaved)}
          primaryLabel={t('Analytics.Co2Saved')}
          secondaryLabel={t('Analytics.FuelSaved')}
          body={` ${
            transactionsStatistics?.data?.kwhCharged
              ? chargedValue > 0
                ? (chargedValue / divisor).toFixed(1)
                : chargedValue
              : '-'
          } ${unit} ${t('Analytics.FootprintBody')}`}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          title={t('Analytics.AvergaeAddMoney')}
          subtitle={t('Analytics.SinceThisMonth')}
          percentage={transactionsStatistics?.data?.addMoneyAverageChange}
          primaryValue={Math.ceil(
            transactionsStatistics?.data?.averageAddMoneyPerUser,
          )}
          unit={currency}
          body={` ${
            transactionsStatistics?.data?.averageWalletBalance
              ? formatNumber(transactionsStatistics?.data?.averageWalletBalance)
              : '-'
          } ${currency} ${t('Analytics.WalletsBalance')}`}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
      </div>
      <div className={Styles.Bottom}>
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.Connectors')}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.connectorsUsed,
          )}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.Charged')}
          primaryValue={
            chargedValue > 0
              ? (chargedValue / divisor).toFixed(1)
              : chargedValue
          }
          unit={unit}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.Time')}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.timeChargedHours,
          )}
          unit={t('Analytics.Hours')}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.TransactionsCard')}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.transactions,
          )}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
        <AnalyticsDataCard
          size="small"
          title={t('Analytics.AddedMoney')}
          primaryValue={formatNumber(
            transactionsStatistics?.data?.totalMoneyCollected,
          )}
          isLoading={
            fetchTransactionsStatisticsRequestState === RequestState.LOADING
          }
          showDash={
            !(
              fetchTransactionsStatisticsRequestState ===
                RequestState.LOADING ||
              fetchTransactionsStatisticsRequestState ===
                RequestState.SUCCEEDED ||
              fetchTransactionsStatisticsRequestState ==
                RequestState.UNINITIALIZED
            )
          }
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  transactionsStatistics: AnalyticsSelectors.getTransactionsStatistics(state),
  fetchTransactionsStatisticsRequestState:
    AnalyticsSelectors.getFetchTransactionsStatisticsRequestState(state),
})
function mapDispatchToProps(dispatch) {
  return {
    fetchTransactionsStatistics: (filter) =>
      dispatch(AnalyticsActions.fetchTransactionsStatistics(filter)),
  }
}
TransactionsStatsCard.propTypes = {
  transactionsStatistics: PropTypes.object,
  fetchTransactionsStatistics: PropTypes.func,
  fetchTransactionsStatisticsRequestState: PropTypes.number,
  currency: PropTypes.string,
  filter: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransactionsStatsCard)
